import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";

import Loader from "../../components/NewView/Common/Loader";

const NewsDetailsComponent = React.lazy(() =>
  import("../../components/NewView/RootComponents/NewsDetailsComponent")
);

const NewsDetailsPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Loader />}>
        <Helmet>
          <title>Новина Yellow Hub</title>
          <meta
            name="description"
            content="Події, історії та новини Yellow Hub."
          />
        </Helmet>
        <NewsDetailsComponent />
      </Suspense>
    </Fragment>
  );
};

export default NewsDetailsPage;
